<style lang="less" scoped>
  .td_left {width: 1.6rem;text-align-last: left;text-indent: .06rem;background-color: #fcfcfc;}
  .after {text-align: left;background-color: #fcfcfc;}
  .after .el-button {height: 0.4rem;}
  .f_red {color: red;margin-right: .03rem;}
  .f_hid {color: #ffffff;margin-right: .03rem;}
  tr,td {border: .01rem solid #f5eeee;padding: .03rem;border-bottom: .01rem solid #f5eeee;}
  .tr .td {float: left;}
  .tr {width: 100%;height: 0.3rem;}
  .td {margin-left: .2rem;}
  table {border-collapse: collapse;width: 100%;}
  .el-checkbox__inner {border-radius: 50%;}
  .first .introduce {width: 100%;}
  .first /deep/ .el-input {width: 4rem;}
  .level /deep/ .el-input {width: 2rem;}
  .ssgj_tr /deep/ .el-input {width: 4rem;}
  .edui-default /deep/ .edui-editor-iframeholder {height: 40%;}
  .el-form-item {margin-bottom: 0;float: left;}
  .jianjie_tr .el-form-item {width: 100%;}
  .catid_tr .el-form-item:nth-of-type(2) {margin-left: .2rem;}
  .tr2 .el-form-item:nth-of-type(2) {margin-left: .2rem;}
  /deep/.el-upload-list--picture-card .el-upload-list__item-thumbnail {position: absolute;margin: auto;top: -6.24rem;right: -6.24rem;bottom: -6.24rem;left: -6.24rem;height: auto}
  .formBox {padding-bottom: 0.5rem;}
  .btnfixed {margin: 0rem auto;z-index: 19999;}
  .btnfixed .el-button {height: 0.4rem;margin: .1rem auto;}
  .btnfixed {position: fixed;bottom: 0;left: 0;right: 0;height: 0.4rem;background: #f8f4f4;margin-left: 2.4rem;background-color: #dff0d8;}
  /deep/.el-form-item__error {font-size: 0.16rem;height: 0.4rem;line-height: 0.4rem;float: right;margin-left: .1rem;position:static;padding-top: 0;}
  /deep/.el-icon-close-tip {display: none;}
  /deep/.el-dialog__wrapper {z-index: 20000 !important;}
  /deep/.hide .el-upload--picture-card {display: none;}
</style>
<template>
  <div class="first" id="first">
    <el-form ref="form" :model="form" :rules="rules" class="formBox">
      <table>
        <tr class="jianjie_tr">
          <td class="td_left">
            <span v-if="isMandatory('introduce')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>简介
          </td>
          <td class="after">
            <el-form-item>
              <el-input type="textarea" v-model="form.introduce" :rows="2" class="introduce" style="font-size: .16rem;"></el-input>
            </el-form-item>
          </td>
        </tr>
        <tr>
          <td class="td_left">
            <span v-if="isMandatory('thumb')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>标题图片
          </td>
          <td class="after">
            <el-upload
              v-if="this.$route.path === '/Gywmgl'"
              :action="url"
              :limit="1"
              list-type="picture-card"
              ref="uploadPic"
              :before-upload="beforeUploadPicture"
              :on-preview="handlePictureCardPreview"
              :on-success="onSuccess"
              :on-change="handleEditChange"
              :class="{hide:hideUploadEdit}"
              :on-remove="handleRemovePicture"
              @mouseover.native="getPhoUrl"
              :on-exceed="exceed">
              <i class="el-icon-plus"></i>
            </el-upload>
            <el-upload
              v-else
              :action="url"
              :limit="1"
              list-type="picture-card"
              :file-list="fileList"
              :before-upload="beforeUploadPicture"
              :on-preview="handlePictureCardPreview"
              :on-success="onSuccess"
              :on-change="handleEditChange"
              :class="{hide:hideUploadEdit}"
              :on-remove="handleRemovePicture"
              @mouseover.native="getPhoUrl"
              :on-exceed="exceed">
              <i class="el-icon-plus"></i>
            </el-upload>
            <el-dialog :visible.sync="dialogVisible">
              <img :src="dialogImageUrl" width=100% />
            </el-dialog>
          </td>
        </tr>
        <tr>
           <td class="td_left">
            <span v-if="isMandatory('thumb')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>视频
          </td>
          <td class="after">
            <el-upload
              class="upload-demo"
              :action="url"
              :limit="1"
              :on-success="onSuccess1"
              :on-remove="handleRemoveVideo"
              :on-change="handleEditChange"
              :class="{hide:hideUploadEdit}"
              :before-upload="beforeUploadVideo"
              @mouseover.native="getVidUrl"
              :on-exceed="exceed">
              <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
              <!-- <el-button style="margin-left: 15px;" size="small" type="success" @click="preview1()">点击预览</el-button> -->
            </el-upload>
          </td>
        </tr>
        <tr>
          <td class="td_left">
           <span v-if="isMandatory('phone')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>电话号
          </td>
          <td class="after">
            <el-form-item>
               <el-form-item>
              <el-input v-model="form.phone" class="input title"></el-input>
            </el-form-item>
            </el-form-item>
          </td>
        </tr>
         <tr class="tr2">
          <td class="td_left">
            <span v-if="isMandatory('fax')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>传真
          </td>
          <td class="after title_right">
            <el-form-item>
              <el-input v-model="form.fax" class="input title"></el-input>
            </el-form-item>
          </td>
        </tr>
        <tr class="tr2">
          <td class="td_left">
            <span v-if="isMandatory('email')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>邮箱
          </td>
          <td class="after title_right">
            <el-form-item>
              <el-input v-model="form.email" class="input title"></el-input>
            </el-form-item>
          </td>
        </tr>
        <tr class="tr2">
          <td class="td_left">
            <span v-if="isMandatory('address')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>地址
          </td>
          <td class="after title_right">
            <el-form-item>
              <el-input v-model="form.address" class="input title" ></el-input>
            </el-form-item>
          </td>
        </tr>
        <tr class="tr2">
          <td class="td_left">
            <span v-if="isMandatory('zipcode')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>邮编
          </td>
          <td class="after title_right">
            <el-form-item>
              <el-input v-model="form.zipcode" class="input title"></el-input>
            </el-form-item>
          </td>
        </tr>
        <tr class="tr2">
          <td class="td_left">
            <span v-if="isMandatory('contacts')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>联系人
          </td>
          <td class="after title_right">
            <el-form-item>
              <el-input v-model="form.contacts" class="input title"></el-input>
            </el-form-item>
          </td>
        </tr>
        <tr class="addtime_tr" v-if="this.$route.path === '/Gywmgl'">
          <td class="td_left">
            <span v-if="isMandatory('addtime')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>添加时间
          </td>
          <td class="after">
            <el-form-item>
              <div class="block">
                <el-date-picker v-model="form.addtime" value-format="timestamp" type="datetime" placeholder="请选择添加时间，不选则默认当前时间"></el-date-picker>
              </div>
            </el-form-item>
          </td>
        </tr>
      </table>
    </el-form>
    <div class="btnfixed">
      <el-button type="success" @click="addfn()" v-if="this.$route.path === '/Gywmgl'">添加</el-button>
      <el-button type="success" @click="modification" v-else-if="this.$route.path === '/GywmUpdate'">确定</el-button>
      <el-button @click="cancelfn()" v-if="this.$route.path === '/Gywmgl'">取消</el-button>
      <el-button @click="backtrack" v-else-if="this.$route.path === '/GywmUpdate'">返回</el-button>
    </div>
  </div>
</template>
<script>
/**
 * 何宽
 * 矿业资讯后台添加页
 */
import {mapState} from 'vuex'
// import E from 'wangeditor'
export default {
  components: {
  },

  props: ['updataID'],
  data()
  {
    //链接验证规则
    let InputFromurl = (rule, value, callback) =>
    {
      let regtel = /(http|ftp|https):\/\/[\w\-_]+(\.[\w\-_]+)+([\w\-.,@?^=%&:/~+#]*[\w\-@?^=%&/~+#])?/
      if (value)
      {
        if (!regtel.test(value))
          callback(new Error('请输入正确来源链接，http://www.'))
        else
          callback()
      }
      else
        callback()
    }
    return {
      url: '',
      checked_External_links: false,
      form: {
        introduce: null,
        thumb: '',
        video: '',
        phone: '',
        fax: '',
        email: '',
        address: '',
        zipcode: '',
        contacts: '',
        addtime: null
      },
      username: '',
      // 富文本对象
      editor: null,
      //所属分类数据
      classifydata: [],
      //预览弹框
      dialogVisible: false,
      //预览路径
      dialogImageUrl: '',
      fileList: [{url: ''}],
      //审核
      examine: '',
      examineInfo: '',

      //rules对象的属性名要与表单中prop绑定的名字一致
      rules: {
        fromurl: [
          { validator: InputFromurl, trigger: 'blur' }
        ]
      },
      
      level_data: [
        { value: '1', label: '1 级 网站首页推荐' },
        { value: '2', label: '2 级' },
        { value: '3', label: '3 级' },
        { value: '4', label: '4 级' },
        { value: '5', label: '5 级' },
        { value: '6', label: '6 级' },
        { value: '7', label: '7 级' },
        { value: '8', label: '8 级' },
        { value: '9', label: '9 级' }
      ],
      ssgj_data: [
        { value: 0, label: '不限地区' },
        { value: 2, label: '中国' },
        { value: 3, label: '印度尼西亚' },
        { value: 4, label: '马来西亚' },
        { value: 5, label: '菲律宾' },
        { value: 6, label: '新加坡' },
        { value: 7, label: '泰国' },
        { value: 8, label: '文莱' },
        { value: 9, label: '越南' },
        { value: 10, label: '老挝' },
        { value: 11, label: '缅甸' },
        { value: 12, label: '柬埔寨' },
        { value: 13, label: '其它' },
        { value: 14, label: '东帝汶' }
      ],

      //表名
      tabname: 'dmcn_aboutus',
      //fld表数据
      fldData: [],
      fldContentData: [],
      hideUploadEdit: false

    }
  },
  // 根据左侧菜单栏获取模块id
  computed:
  {
    ...mapState({
      curID: state => state.NavID
    })
  },
  watch:
  {
    curID:
    {
      handler(nval, oval)
      {
        //获取分类下拉列表
        window.public.getFldvalue(nval, 'catid').then((ret) =>
        {
          this.classifydata = []
          ret.forEach((item) => this.classifydata.push({ value: item.id, label: item.dispc }))
        })
      },
      immediate: true
    }
  },
  async created()
  {
    //创建富文本编辑器
    setTimeout(() =>
    {
      let that = this
      window.public.createEditor(that)
    }, 50)
    // //创建富文本编辑器
    // setTimeout(() =>
    // {
    //   // let that = this
    //   // window.public.createEditor(that)

    //   const editor = new E('#editor')
    //   // base64 保存图片
    //   editor.config.uploadImgShowBase64 = false

    //   // 配置 server 接口地址
    //   editor.config.uploadImgServer = 'http://192.168.2.201:8083/svr/DocSvr?cmd=upload&major=11&minor=1&username=admin&fid=11&sys=11&dir=&entityid=1&glid=0&task=Dmky'

    //   editor.config.customUploadImg = function(resultFiles, insertImgFn)
    //   {
    //     console.log(resultFiles)
    //     console.log(insertImgFn)
    //     let Ip = window.location.hostname
    //     let UrlType = ''
    //     if (Ip === '127.0.0.1')
    //       UrlType = 'svr/DocSvr'
    //     else if (Ip === 'localhost')
    //       UrlType = 'svr/DocSvr'
    //     else
    //       UrlType = 'DocSvr'

    //     let data = {
    //       cmd: 'upload',
    //       major: 11,
    //       minor: 1,
    //       entityid: 1,
    //       username: 'name',
    //       fid: 1,
    //       sys: 11,
    //       task: '',
    //       dir: '',
    //       glid: '0'
    //     }
    //     let params = {
    //       url: UrlType,
    //       title: '',
    //       tip: '',
    //       data: data
    //     }


    //     // let params = {
    //     //   cmd: 'upload'
    //     // }

    //     window.post.getDocSvr(params).then(ret =>
    //     {
    //     })

    //     // let prefix = ''
    //     // if (Ip === 'www.camining.cn')
    //     //   prefix = 'http://www.camining.cn/uploadfile/'
    //     // else if (Ip === 'camining.cn')
    //     //   prefix = 'http://www.camining.cn/uploadfile/'
    //     // else
    //     //   prefix = 'http://192.168.2.201:8083/gisdm/uploadfile/'
    //     // insertImgFn(`${prefix}${resultFiles[0].name}`)
    //   }

    //   // 关闭粘贴样式的过滤
    //   editor.config.pasteFilterStyle = false
    //   // 配置 onchange 回调函数，将数据同步到 vue 中
    //   editor.config.onchange = (newHtml) =>
    //   {
    //     this.form.content = newHtml
    //   }
    //   // 隐藏插入网络图片的功能
    //   editor.config.showLinkImg = false
    //   // 限制大小
    //   // editor.config.uploadImgMaxSize = 12 * 1024 * 1024 // 2M
    //   // 限制类型
    //   editor.config.uploadImgAccept = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp']
    //   // 创建编辑器
    //   editor.create()
    //   this.editor = editor
    // }, 50)
    this.fldData = await window.public.validation(this.tabname)
    this.isgetData()
    //根据用户判断审核状态
    let userInfo = JSON.parse(localStorage.getItem('userMsg'))
    this.username = userInfo.userno
    if (userInfo.userno === 'admin')
      this.examine = 0
    else
      this.examine = 1
  },
  methods: {
    //添加
    addfn()
    {
      let obj = {
        cmd: 'add',
        _major: 11,
        _minor: 114,
        retAtt: 1,
        introduce: this.form.introduce,
        thumb: this.form.thumb,
        video: this.form.video,
        phone: this.form.phone,
        fax: this.form.fax,
        email: this.form.email,
        address: this.form.address,
        zipcode: this.form.zipcode,
        contacts: this.form.contacts,
        username: this.username,
        addtime: (Date.parse(new Date()) / 1000)
      }
      window.post.getPost(obj).then((ret) =>
      {
        if (ret.ret === 1)
          this.$message({message: '添加失败，请检查是否有未填写的内容或者填写不规范', type: 'error', customClass: 'mzindex'})
        else
        {
          this.$message({message: '添加成功', type: 'success', customClass: 'mzindex'})
          this.$emit('removeTab')
          this.$store.commit('onIsLb', '1')
        }
      })
    },
    //获取需要修改的数据
    isgetData()
    {
      if (this.$route.path === '/GywmUpdate')
        this.getData()
      else if (this.$route.path === '/Gywmgl')
        return false
    },
    getData()
    {
      let paras = {
        cmd: 'query',
        _major: 11,
        _minor: 114,
        _exp: 'id=?',
        types: 'i',
        vals: this.updataID
      }
      window.post.getPost(paras).then((ret) =>
      {
        this.form.id = ret[0].id
        this.form.introduce = ret[0].introduce
        this.form.thumb = ret[0].thumb
        this.form.phone = ret[0].phone
        this.form.fax = ret[0].fax
        this.form.email = ret[0].email
        this.form.address = ret[0].address
        this.form.zipcode = ret[0].zipcode
        this.form.contacts = ret[0].contacts
        this.fileList[0].url = ret[0].thumb !== '' ? ret[0].thumb : 'static/images/moren.jpg'
      })
    },
    //修改
    modification()
    {
      let obj = {
        cmd: 'updateAtt',
        _major: 11,
        _minor: 114,
        retAtt: 1,
        id: this.form.id,
        introduce: this.form.introduce,
        thumb: this.form.thumb,
        video: this.form.video,
        phone: this.form.phone,
        fax: this.form.fax,
        email: this.form.email,
        address: this.form.address,
        zipcode: this.form.zipcode,
        contacts: this.form.contacts,
        username: this.username,
        addtime: (Date.parse(new Date()) / 1000)
      }
      window.post.getPost(obj).then((ret) =>
      {
        if (ret.ret === 1)
          this.$message({message: '修改失败', type: 'error', customClass: 'mzindex'})
        else
        {
          this.$message({message: '修改成功', type: 'success', customClass: 'mzindex'})
          this.dialogVisible = false
          this.$router.push({path: '/Gywmgl'})
          this.$store.commit('onActiveName', '1')
        }
      })
    },
    //返回
    backtrack()
    {
      this.$router.push({path: '/Gywmgl'})
      this.$store.commit('onActiveName', '1')
    },
    backtrackLook()
    {
      this.$router.push({path: '/ToExamine'})
      this.$store.commit('onActiveName', '1')
    },
    //不通过
    notPass()
    {
      let objcontent = {
        cmd: 'updateAtt',
        _major: 11,
        _minor: 1,
        retAtt: 1,
        id: this.updataID,
        examine: 4
      }
      window.post.getPost(objcontent).then((ret) =>
      {
        if (ret.ret === 1)
          this.$message({message: '审核失败', type: 'error', customClass: 'mzindex'})
        else
        {
          this.$message({message: '该条已为不通过', type: 'error', customClass: 'mzindex'})
          this.dialogVisible = false
          this.$router.push({path: '/ToExamine'})
          this.$store.commit('onActiveName', '1')
        }
      })
    },
    //通过
    isPass()
    {
      let paras = {cmd: 'query', _major: 11, _minor: 1, _exp: `id = ${this.updataID}`}
      window.post.getPost(paras).then((ret) =>
      {
        this.examineInfo = ret[0].examine
        let userInfo = JSON.parse(localStorage.getItem('userMsg'))
        let examine = null
        if (userInfo.role.includes(1) && this.examineInfo === 1)
          examine = 2
        else if (userInfo.role.includes(2) && this.examineInfo === 2)
          examine = 3
        else if (userInfo.role.includes(3) && this.examineInfo === 3)
          examine = 5
        else if (userInfo.role.includes(0))
          examine = 0
        this.upExamine(examine)
      })
    },
    //修改状态
    upExamine(examine)
    {
      let objcontent = {
        cmd: 'updateAtt',
        _major: 11,
        _minor: 1,
        retAtt: 1,
        id: this.updataID,
        examine: examine
      }
      window.post.getPost(objcontent).then((ret) =>
      {
        if (ret.ret === 1)
          this.$message({message: '审核失败', type: 'error', customClass: 'mzindex'})
        else
        {
          this.$message({message: '审核成功', type: 'success', customClass: 'mzindex'})
          this.$router.go(-1)
        }
      })
    },
    //上传图片
    getPhoUrl()
    {
      let that = this
      window.public.onUploadPicture(that)
    },
    //图片上传之前的钩子
    beforeUploadPicture(file)
    {
      let that = this
      window.public.beforeUploadPicture(file, that)
    },
    //上传中
    handlePictureCardPreview(file)
    {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    },
    //图片上传成功
    onSuccess(response)
    {
      let that = this
      window.public.onSuccess(response, that)
    },
    //上传发生变化（上传或者删除）
    handleEditChange(file, fileList)
    {
      let that = this
      window.public.handleEditChange(file, fileList, that)
    },
    //删除图片
    handleRemovePicture(fileList)
    {
      let that = this
      window.public.handleRemovePicture(fileList, that)
    },
    //超出上传次数
    exceed()
    {
      this.$message({message: '您已上传过了，若需要换一个，请先删除上一个', type: 'error', customClass: 'mzindex'})
    },
    getVidUrl()
    {
      let that = this
      window.public.onUploadVideo(that)
    },
    //视频上传之前的钩子
    beforeUploadVideo(file)
    {
      let that = this
      window.public.beforeUploadVideo(file, that)
    },
    //上传视频
    onSuccess1(response)
    {
      let that = this
      window.public.onVideoSuccess(response, that)
    },
    //删除视频
    handleRemoveVideo(fileList)
    {
      let that = this
      window.public.handleRemoveVideo(fileList, that)
    },
    preview1(thumb)
    {
      this.playerOptions.sources[0].src = thumb
      if (this.playerOptions.sources[0].src)
        this.dialogVisible1 = true
      else
        this.$message({message: '您还没有上传视频，暂可内容预览', type: 'error', customClass: 'mzindex'})
    },
    //取消(移除Tabs页)
    cancelfn()
    {
      this.$emit('removeTab')
    },
    /**
     * 标题检测
     * @param {String} major 主类型
     * @param {String} minor 子类型
     * @param {String} title 标题
     */
    detection(major, minor, title)
    {
      let that = this
      window.public.detection(major, minor, title, that)
    },
    //判断是否必填
    isMandatory(colname)
    {
      return window.public.isMandatory(this.fldData, colname)
    },
    //判断富文本内容是否必填
    isContentMandatory(colname)
    {
      return window.public.isMandatory(this.fldContentData, colname)
    }
  }
}
</script>



// WEBPACK FOOTER //
// static/form/GywmAdd.vue